import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncCatechismAdminPage({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/page/catechismAdminPage"));
  console.log("Loading", AsyncCatechismAdminPage.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncCatechismAdminPage;
